import { Route } from '../interface';

const initialRouteState: Route = {
    path: undefined,
    url: undefined,
    isExact: undefined,
    params: undefined,
    routeState: undefined,
};

export default initialRouteState;



// WEBPACK FOOTER //
// ./src/redux/initial-state/route.ts